module.exports = __webpack_public_path__ + "img/bmt-altec.png";